import * as React from "react";
import { IdIconTextPosition } from "../../../constants/IdIconTextPosition";
import { IdStyles } from "../../../less/IdStyles";
import { IconWithProgress } from "../icon-with-progress/IconWithProgress";
import { TimerCountdown } from "../timer/TimerCountdown";
export var TimerWithIcon = function (_a) {
    var remainingTime = _a.remainingTime, icon = _a.icon, iconStyle = _a.iconStyle, iconTextComponent = _a.iconTextComponent, progressPercent = _a.progressPercent, tooltipLoca = _a.tooltipLoca, _b = _a.iconTextPosition, iconTextPosition = _b === void 0 ? IdIconTextPosition.Under : _b;
    return (React.createElement(IconWithProgress, { icon: icon, iconStyle: iconStyle, progressPercent: progressPercent, iconTextComponent: iconTextComponent, iconTextPosition: iconTextPosition, fillClassName: IdStyles.ProgressBarFill, backgroundClassName: IdStyles.ProgressBarBackground, tooltipLoca: tooltipLoca },
        React.createElement(TimerCountdown, { className: "timer-with-icon__content " + IdStyles.TextBoldAccent, remainingTime: remainingTime })));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/generic/timer-with-icon/TimerWithIcon.tsx
// module id = 871
// module chunks = 3